import Summary from "@/UDTreat/USmartForms/Summary"

const SummaryView = () => {
  return <Summary needToSubmit={true}/>
}

export default SummaryView
